import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _to_property_key } from "@swc/helpers/_/_to_property_key";
// WHY: pure immutable algebra over a QuantifierCollection (any/all/none -> predicate map);
// every operation returns a new collection so callers never mutate shared state.
import { SERVICE_QUANTIFIERS } from '~/types/api/drafts-search';
const isEmptyDeep = (value)=>{
    if (value == null) return true;
    if (typeof value === 'string') return value.trim().length === 0;
    if (Array.isArray(value)) return value.every(isEmptyDeep);
    if (typeof value === 'object') return Object.values(value).every(isEmptyDeep);
    return false;
};
const hasOwnKeys = (predicate)=>predicate != null && typeof predicate === 'object' && Object.keys(predicate).length > 0;
const quantifierIsEmpty = (collection, quantifier)=>!hasOwnKeys(collection[quantifier]);
export const isPredicateEmpty = (predicate)=>isEmptyDeep(predicate);
export const isCollectionEmpty = (collection)=>SERVICE_QUANTIFIERS.every((quantifier)=>quantifierIsEmpty(collection, quantifier));
export const presentCollectionEntries = (collection)=>SERVICE_QUANTIFIERS.flatMap((quantifier)=>{
        const predicate = collection[quantifier];
        if (predicate === undefined || !hasOwnKeys(predicate)) return [];
        return [
            {
                quantifier,
                predicate
            }
        ];
    });
export const presentCollectionQuantifiers = (collection)=>presentCollectionEntries(collection).map((entry)=>entry.quantifier);
export const moveCollectionQuantifier = (collection, from, to)=>{
    if (from === to || !quantifierIsEmpty(collection, to)) return collection;
    const { [from]: moved } = collection, rest = _object_without_properties(collection, [
        _to_property_key(from)
    ]);
    return _object_spread_props(_object_spread({}, rest), {
        [to]: moved
    });
};
export const nextCollectionQuantifier = (collection, from)=>{
    const target = from === 'none' ? 'any' : 'none';
    return quantifierIsEmpty(collection, target) ? target : from;
};
export const setCollectionQuantifier = (collection, quantifier, predicate)=>{
    const { [quantifier]: _omit } = collection, rest = _object_without_properties(collection, [
        _to_property_key(quantifier)
    ]);
    const next = hasOwnKeys(predicate) ? _object_spread_props(_object_spread({}, rest), {
        [quantifier]: predicate
    }) : rest;
    return isCollectionEmpty(next) ? undefined : next;
};
